var TEMPLATE_URL = require('./eol-notice.html');

angular.module('ikeweb.layout').directive('eolNotice', [
    function() {
        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {},
            controllerAs: 'ctrl',
            controller: function() {
                this.eolTermsUrl = 'https://spike.ikegps.com/eol-notice/';
            }
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/eol-notice/eol-notice.directive.js
// module id = 448
// module chunks = 0